// services/localStorageService.js

export const CACHE_KEYS = {
    CATEGORIES: 'complaintCategories',
    TYPES: 'complaintTypes',
};

const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

// Get data from localStorage with expiration check
export const getCachedData = (key) => {
    try {
        const cached = localStorage.getItem(key);
        if (!cached) return null;

        const parsed = JSON.parse(cached);
        const now = Date.now();

        // Check if cache is expired
        if (now - parsed.timestamp > CACHE_DURATION) {
            localStorage.removeItem(key);
            return null;
        }

        return parsed.data;
    } catch (error) {
        console.error(`Error reading from localStorage (${key}):`, error);
        return null;
    }
};

// Store data in localStorage with timestamp
export const setCachedData = (key, data) => {
    try {
        const cacheData = {
            data: data,
            timestamp: Date.now(),
        };
        localStorage.setItem(key, JSON.stringify(cacheData));
    } catch (error) {
        console.error(`Error writing to localStorage (${key}):`, error);
    }
};

// Clear specific cache
export const clearCache = (key) => {
    if (key) {
        localStorage.removeItem(key);
    } else {
        // Clear all complaint-related cache
        Object.values(CACHE_KEYS).forEach(k => localStorage.removeItem(k));
    }
};

// Check if cache is valid
export const isCacheValid = (key) => {
    try {
        const cached = localStorage.getItem(key);
        if (!cached) return false;

        const parsed = JSON.parse(cached);
        const now = Date.now();
        return (now - parsed.timestamp) <= CACHE_DURATION;
    } catch {
        return false;
    }
};